import Bubble from './bubble'
export default (Vue, options) => {
	Vue.component('chartjs-bubble', Bubble)
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/config/charts.js